const getConfig = async (section: String) => {
  const config = await fetch(`/config/config.json`);
  const configAsJson = await config.json();

  return section === "" ? configAsJson : configAsJson[section.toString()];
};

export { getConfig };
